// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "main/css/" + "about" + "." + "4ba99f5b" + ".css";
};